import React, { useRef } from 'react';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { SpacingStack } from '@components/SpacingStack';
import { CTALink } from '@components/CTALink';
import { ColumnWrapper, StyledButton, TextPairingWrapper, StyledConnectedGuestList } from './ConnectedGuestListSection.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { useTranslation } from 'react-i18next';

export const ConnectedGuestListStatic: React.FC<{ page: MarcomPageName }> = ({ page }) => {
  const { t } = useTranslation('weddingWebsitePage');
  const { eyebrow, title, getStarted, learnMore, image } = t('connectedGuestList');
  const sectionId = 'Wedding_Websites_Guest_List_Cross';
  const sectionRef = useRef<HTMLDivElement>(null);
  const lottieRef = useRef<HTMLDivElement>(null);
  return (
    <Box backgroundColor="yellow1" paddingTop={[10, 12]} id={sectionId} ref={sectionRef}>
      <LazyLoadWrapper>
        <div />
      </LazyLoadWrapper>
      <Box style={{ maxWidth: '1440px', margin: 'auto' }}>
        <SpacingStack spacing={[10]}>
          <Columns centered={true}>
            <ColumnWrapper width="full">
              <Box>
                <TextPairingWrapper
                  alignment="center"
                  eyebrow={eyebrow}
                  eyebrowColor="humana4"
                  eyebrowVariant="calloutHed32"
                  eyebrowTagName="h2"
                  title={title}
                  titleVariant="hed96Break"
                  titleColor="neutra6"
                  titleTagName="h2"
                />
                <Flex alignItems="center" justifyContent="center" paddingY={[10]}>
                  <Box marginRight={[10]}>
                    <StyledButton id="connectedGuestListCreate" variant="secondary" forwardedAs={'a'} href={getCreateWeddingUrl(page)}>
                      {getStarted}
                    </StyledButton>
                  </Box>
                  <Box>
                    <CTALink id="connectedguestListLearnMore" aria-label="Guest List" href="/guest-list">
                      {learnMore}
                    </CTALink>
                  </Box>
                </Flex>
              </Box>
              <Box id="ConnectedGuestListStatic" ref={lottieRef}>
                <StyledConnectedGuestList src={image} alt="connected guest list" optimization="default" />
              </Box>
            </ColumnWrapper>
          </Columns>
        </SpacingStack>
      </Box>
    </Box>
  );
};

export default ConnectedGuestListStatic;
